import i18n from '@components/i18n/i18n';
import {
  FieldCheckbox,
  FieldCheckboxInput,
  FieldCheckboxLabel,
} from './VariantCheckbox.styles';

// TODO: Checkbox component should display an error
/* eslint-disable no-unused-vars */
const VariantCheckbox = ({
  id,
  name,
  label,
  register,
  errors,
  checkboxStyle,
  labelStyle,
  showBorder = true,
  dark = false,
  ...rest
}) => {
  const language = i18n.language;
  const dir = i18n.dir();

  return (
    <FieldCheckbox showBorder={showBorder}>
      <FieldCheckboxInput
        id={id}
        className={[language, dir].join(' ')}
        name={name}
        ref={register}
        dark={!!dark}
        style={checkboxStyle}
        {...rest}
      />
      <FieldCheckboxLabel
        htmlFor={id}
        dark={!!dark}
        style={labelStyle}
        {...rest}
      >
        {label}
      </FieldCheckboxLabel>
    </FieldCheckbox>
  );
};

export default VariantCheckbox;
